var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM10.4042 3.64789C10.5986 3.84395 10.5973 4.16053 10.4013 4.35499L7.7346 7L10.4013 9.64501C10.5973 9.83947 10.5986 10.156 10.4042 10.3521C10.2097 10.5482 9.89313 10.5495 9.69707 10.355L7.02459 7.70424L4.35211 10.355C4.15605 10.5495 3.83947 10.5482 3.64501 10.3521C3.45054 10.156 3.45184 9.83947 3.64789 9.64501L6.31458 7L3.64789 4.35499C3.45184 4.16053 3.45054 3.84395 3.64501 3.64789C3.83947 3.45184 4.15605 3.45054 4.35211 3.64501L7.02459 6.29576L9.69707 3.64501C9.89313 3.45054 10.2097 3.45184 10.4042 3.64789Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/CloseCircle.28ccd2b5ab38130f3d5b90b8e464261f.svg";
export { ForwardRef as ReactComponent };